module.exports = __webpack_public_path__ + "static/media/SegundaFranja_Manomoneda.32b238ac.png";